<template>
  <div class="page-wrapper">
    <div class="main">
      <div class="right">
        <div>
          <el-popover
            placement="bottom-end"
            width="300"
            trigger="click">
            <el-input size="small" placeholder="请输入内容" v-model="copyUrl" readonly>
              <el-button slot="append" icon="el-icon-document-copy"
                v-clipboard:copy="copyUrl"
                v-clipboard:success="onCopySuccess"
                v-clipboard:error="onCopyError"
                title="copy"
              ></el-button>
            </el-input>
            <el-button slot="reference"
              type="primary"
              plain
              size="small"
            >复制链接</el-button>
          </el-popover>
          <el-button
            style="margin-left: 10px"
            type="primary"
            plain
            size="small"
            @click="toEditCourse"
            >编辑</el-button
          >
          <el-button
            v-if="detail.state == 1"
            type="primary"
            plain
            size="small"
            @click="updateStateHandle(2)"
            >下架</el-button
          >
          <el-button
            v-if="detail.state == 2"
            type="primary"
            plain
            size="small"
            @click="updateStateHandle(1)"
            >发布</el-button
          >
        </div>
        <div class="price">
          <span>￥</span><strong>99</strong>
        </div>
      </div>
      <div class="tit">{{detail.name}}</div>
      <div class="intro">{{detail.brief}}</div>
      <div class="info">上课时间：{{detail.startT}}至{{detail.endT}}</div>
      <div class="info">上课地点：{{detail.region}} {{detail.address}}</div>
      <div class="info">课程来源：{{detail.sourceName}}</div>
      <div class="info">
        课程状态：
        <el-tag  type="success" v-if="detail.state === 1">在售</el-tag>
        <el-tag  type="danger" v-if="detail.state === 2">已下架</el-tag>
      </div>
      <div class="detail-imgs">
        <img v-for="(url, index) in detail.pics" :key="index" :src="url">
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from '@/common/common.js'
import { api, request } from '@/common/request_course.js'
import { Loading } from 'element-ui';
import { buildThumborUrl } from '@/common/tool.js'
import qs from 'qs'
export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
    copyUrl() {
      let env = utils.getCurrentApi()
      if (env == 'dev') {
        return 'https://www.dev.fzzht.com/services-fashion-college-course.html?id=' + this.$route.query.id
      } else if (env == 'test') {
        return 'https://www.test.fzzht.com/services-fashion-college-course.html?id=' + this.$route.query.id
      } else if (env == 'prod') {
        return 'https://www.fzzht.com/services-fashion-college-course.html?id=' + this.$route.query.id
      } else {
        return 'https://www.fzzht.com/services-fashion-college-course.html?id=' + this.$route.query.id
      }
    }
  },
  inject: ["reload"],
  data() {
    return {
      detail: {
        name: '',
        brief: '',
        startT: '',
        endT: '',
        region: '',
        address: '',
        sourceName: '',
        pics: []
      }
    };
  },
  watch: {},
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let loadingInstance = Loading.service({
        text: '载入数据...'
      });
       request({
        url: api.baseUrl + "/course/detail",
        method: "get",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        params: {
          courseId: this.$route.query.id
        }
      })
      .then((res) => {
        console.log(res);
        loadingInstance.close()
        if (res.erroyCode == 200) {
          let data = res.data
          let sourceName = data.source == 1 ? '自营课程' : data.source == 2 ? '合作机构课程' : '-'; 
          this.detail = {
            ...data,
            startT: data.startTime.slice(0, 16),
            endT: data.endTime.slice(0, 16),
            region: data.provinceName + ' ' + data.cityName + ' ' + data.districtName,
            sourceName,
            pics: data.detailPicture.map(url => buildThumborUrl(url))
          }
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      })
      .catch((err) => {
        loadingInstance.close()
        console.log(err);
      })
    },
    toEditCourse() {
      this.$router.push('/course/edit?id=' + this.$route.query.id)
    },
    onCopySuccess() {
      console.log('复制成功')
      this.$message.success('复制成功')
    },
    onCopyError() {
      console.log('复制失败')
    },
    // 上下架
    updateStateHandle(state) {
      let tip = ''
      if (state == 1) tip = '确定发布该课程吗？'
      if (state == 2) tip = '确定下架该课程吗？'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.requestUpdateState(state)
      }).catch(() => {
        console.log('已取消')
      })
    },
    requestUpdateState(state) {
      let loadingInstance = Loading.service({
        text: '正在提交...'
      });
      console.log('dfasfd')
      request({
        url: api.baseUrl + "/course/updateByState",
        method: "post",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify({
          courseId: this.detail.id,
          state,
          updateBy: this.adminId
        })
      })
      .then((res) => {
        console.log(res);
        loadingInstance.close()
        if (res.erroyCode == 200) {
          this.detail.state = state
          let tip = state == 1 ? '发布' : 
            state == 2 ? '下架' : '操作'
          this.$message.success(`${tip}成功`)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      })
      .catch((err) => {
        loadingInstance.close()
        console.log(err);
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
  .main {
    margin: 0 auto;
    width: 980px;
    position: relative;
    .tit {
      color: #333;
      padding: 24px 0;
      font-size: 32px;
    }
    .intro {
      margin-bottom: 24px;
      font-size: 14px;
      color: #666;
    }
    .info {
      margin-top: 12px;
      color: #000;
      font-size: 14px;
    }
    .detail-imgs {
      margin-top: 32px;
      min-height: 400px;
      width: 980px;
      img {
        display: block;
        max-width: 100%;
      }
    }
    .right {
      position: absolute;
      right: 0;
      top: 0;
      padding-top: 36px;
      .price {
        padding: 16px 0;
        color: #F91521;
        font-size: 36px;
        text-align: right;
        span {
          font-size: 18px;
        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/course/detail.vue